import { Component, effect, ElementRef, inject, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InfologService } from '../../services/infolog.service';
import { InfologMessage } from '../../services/infolog.service';

@Component({
  selector: 'app-infolog',
  templateUrl: './infolog.component.html',
  styleUrls: ['./infolog.component.scss'],
})
export class InfologComponent {
  @ViewChild('logBody') logBody!: ElementRef<HTMLDivElement>;

  
  constructor(public infolog: InfologService) {
    effect(() => { //re-runs every time messages signal changes to scroll to bottom of log
      this.infolog.messages(); 
      setTimeout(() => {
        this.logBody?.nativeElement?.scrollTo({
          top: this.logBody.nativeElement.scrollHeight,
          behavior: 'smooth',
        });
      }, 0);
    });
  }

}